import * as React from 'react'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import * as s from './WholesalerPortal.scss'

export class WholesalerPortal extends React.Component<any> {
  // componentWillMount () {
  //   console.log(this.props)
  // }
  render() {
    return (
      <div className={cn(sLay['flex'], sLay['layout-column'])}>
        <div className={s.header}>Analytics: {location.hostname}</div>
        <div className={cn(sLay['flex'], sLay['layout-column'], s.body)}>{this.props.children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/WholesalerPortal/WholesalerPortal.tsx